<template>
  <div
    class="bg-white rounded-xl p-2 shadow-md text-[12px] w-full max-w-sm mx-auto mb-3"
    :class="{ 'border border-red-500': product.errors }"
  >
    <div class="flex items-center text-center">
      <!-- عکس وسط -->
      <router-link :to="`/product/${product.kala_Code}`" class="mb-2 relative">
        <DiscountBadge
          :discount="product.dscnt_Percent"
          class="top-0 -right-2 absolute"
        />
        <img :src="product.imgUrl" class="w-20 h-20 object-cover rounded" />
      </router-link>

      <!-- اطلاعات محصول -->
      <div class="space-y-1  flex flex-col flex-1 justify-center items-center">
        <p class="truncate max-w-[150px] font-semibold text-gray-800">
          {{ product.kala_Name || "بدون نام" }}
        </p>
        <p>تعداد در بسته: {{ product.pack_Value }}</p>
        <p>
          قیمت واحد:
          <span class="text-green-600 font-bold">{{
            $helper.priceFormatter(product.nerkH_WITH_TAX / 10)
          }}</span>
        </p>
        <p>
          قیمت بسته:
          <span class="text-green-600 font-bold">{{
            $helper.priceFormatter(
              (product.nerkH_WITH_TAX * product.pack_Value) / 10
            )
          }}</span>
        </p>
        <p class="text-red-600 font-bold border-t pt-1">
          جمع کل: {{ $helper.priceFormatter(totalPrice) }}
        </p>
        <ProductOrderButtons :product="product" />
      </div>
    </div>
  </div>
</template>
<script>
import DiscountBadge from "@/components/DiscountBadge";
import ProductOrderButtons from "@/components/ProductOrderButtons";
export default {
  name: "ShoppingCartItem",
  components: { DiscountBadge, ProductOrderButtons },
  props: ["product"],
  computed: {
    count() {
      return this.$store.getters["cart/productCount"](this.product.kala_Code);
    },
    totalPrice() {
      return (
        (this.product.pack_Value * this.product.nerkH_WITH_TAX * this.count) /
        10
      );
    },
  },
};
</script>
